
// Réexportation depuis le hook
// Nous inversons l'importation pour éviter les dépendances circulaires
import { useToast as useToastHook, toast as toastFunction } from "@/hooks/use-toast";

export const useToast = useToastHook;
export const toast = toastFunction;
